var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowHideBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "SvgjsSvg1001",
    width: 288,
    height: 288,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlnsSvgjs: "http://svgjs.com/svgjs",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "SvgjsDefs1002"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SvgjsG1008"
  }, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    width: 288,
    height: 288,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 9811",
    transform: "translate(-927 -52)",
    fill: "#0e0e0e",
    className: "color000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c3838",
    d: "M15,0A15,15,0,1,1,0,15,15,15,0,0,1,15,0Z",
    "data-name": "Path 3627",
    opacity: 0,
    transform: "translate(927 52)",
    className: "color3c3838 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#121212",
    d: "M176.493,198.623a.651.651,0,0,1-.474-.209l-7.329-7.806a.746.746,0,0,1,0-1.008.641.641,0,0,1,.947,0l6.856,7.3,6.857-7.3a.641.641,0,0,1,.947,0,.746.746,0,0,1,0,1.008l-7.33,7.805a.65.65,0,0,1-.474.209Z",
    "data-name": "Path 10511",
    transform: "translate(765.507 -126.738)",
    className: "colorfff svgShape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowHideBlack);
export default __webpack_public_path__ + "static/media/show-hide-black.e7dbf99ade7275c68cc75e5c85791420.svg";
export { ForwardRef as ReactComponent };